module.exports = __webpack_public_path__ + "media/application/images/icons/table-next-2ffad3cb67e014a07df8bde44435460b.svg";